// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__1d7UJ","active":"downloadDropdown_active__Qku4n"};